import { API_COMPOSER_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  ComposedScriptedTestCase,
  Error
} from '@eggplant/types'

interface Props {
  testcaseId: string
  onSuccess?: (response: ComposedScriptedTestCase) => void
  onError?: (error: Error) => void
  children?: (response: ComposedScriptedTestCase) => React.ReactNode
  spinnerSize?: number
}

const GetComposerScriptedTestCaseRequest = ({
  testcaseId,
  onSuccess,
  onError,
  children,
  spinnerSize
}: Props) => {
  const url = `${API_COMPOSER_SERVICE}/test_cases/scripted/${testcaseId}`

  return (
    <AuthenticatedDataRequest
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      spinnerSize={spinnerSize}
      url={url}
    >
      {children}
    </AuthenticatedDataRequest>
  )
}

export default GetComposerScriptedTestCaseRequest
